import { useMutation } from "@tanstack/react-query";
import AIToolsAPI from "../../api/AIToolsAPI";
import { newToastEvent } from "../../../utils/ToastUtil";

export interface MappedDomain {
  key: string;
  Domain: string;
  Email: string;
  FirstName: string;
  companyId: string;
  companyName: string;
  _RecordName: string;
  _id: string;
}

const useDomainMapper = () => {
  const domainMapper = useMutation({
    mutationFn: ({
      selectedCompanies,
      maximumContacts,
      excludeOptions,
    }: {
      selectedCompanies: string[];
      maximumContacts?: number;

      excludeOptions: string[] | [];
    }) => {
      return AIToolsAPI.brieDomainMapper({
        selectedCompanies,
        maximumContacts,
        excludeOptions,
      });
    },
  });

  const domainMapperApply = useMutation({
    mutationFn: ({
      selectedMappedDomains,
    }: {
      selectedMappedDomains: MappedDomain[];
    }) => {
      return AIToolsAPI.brieDomainMapperApply({ selectedMappedDomains });
    },
    onError: (err) => {
      newToastEvent("error", "We had an error applying your mapped domains.");
    },
    onSuccess: () => {
      newToastEvent("success", "Successfully applied mapped domains.");
    },
  });

  return {
    domainMapper: domainMapper.mutate,
    domainMapperLoading: domainMapper.isPending,
    domainMapperError: domainMapper.error,
    domainMapperValue: domainMapper.data?.data.data.contactsWithMatchWord,
    domainMapperApply: domainMapperApply.mutate,
    domainMapperApplyLoading: domainMapperApply.isPending,
    domainMapperApplyError: domainMapperApply.error,
  };
};

export default useDomainMapper;
